import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CrIconComponent } from './icon.component';

@NgModule({
  imports: [HttpClientModule],
  declarations: [CrIconComponent],
  exports: [CrIconComponent],
})
export class CrIconModule {}
